import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Plus, PencilSimple, Trash } from "@phosphor-icons/react";

export default function InsightsAdmin() {
  const [items, setItems] = useState([]);

  const load = async () => { const r = await api.get("/insights"); setItems(r.data); };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete post?")) return;
    await api.delete(`/insights/${id}`); toast.success("Deleted"); load();
  };

  return (
    <div data-testid="admin-insights" className="p-8 md:p-10">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <h1 className="font-display font-black text-3xl md:text-4xl">Insights / Blog</h1>
        <Link to="/admin/insights/new" data-testid="insights-new" className="btn-brand text-sm py-2.5 px-4">
          <Plus size={16} weight="bold" /> New post
        </Link>
      </div>
      <div className="mt-6 bg-white border border-[color:var(--line)]">
        {items.map((p) => (
          <div key={p.id} data-testid={`insight-row-${p.id}`} className="p-5 border-b border-[color:var(--line)] flex items-center gap-4">
            <div className="flex-1 min-w-0">
              <div className="font-semibold">{p.title}</div>
              <div className="text-xs text-neutral-500 flex flex-wrap gap-2 mt-1">
                <span className="font-mono">{p.slug}</span>
                {p.published ? <span className="text-emerald-700">published</span> : <span className="text-amber-600">draft</span>}
                <span>{(p.tags || []).join(", ")}</span>
              </div>
            </div>
            <div className="flex gap-2">
              <Link to={`/admin/insights/${p.id}/edit`} data-testid={`insight-edit-${p.id}`} className="border border-[color:var(--line)] p-2 hover:border-black transition-colors">
                <PencilSimple size={14} />
              </Link>
              <button onClick={() => del(p.id)} data-testid={`insight-del-${p.id}`} className="border border-[color:var(--line)] p-2 hover:border-[color:var(--brand)] hover:text-[color:var(--brand)] transition-colors">
                <Trash size={14} />
              </button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="p-6 text-neutral-500 text-sm">No posts yet.</div>}
      </div>
    </div>
  );
}
